export const environment = {
  env: 'dev',
  ddg_enabled: true,
  production: true,
  API: 'https://api.dev.xref.io/',
  ID_API: 'https://id.dev.xref.io/',
  AUTH_API: 'https://auth.dev.xref.io/',
  LOGIN_URL: 'https://login.dev.xref.com/',
  SURVEY_URL: 'https://survey.dev.xref.io/',
  HELP_URL: 'https://help.dev.xref.com/',
  DOMAIN: 'https://app.dev.xref.com/',
  COOKIE_DOMAIN: 'xref.com',
  RECRUITER_URL: 'https://employer.dev.xref.com/',
  ENGAGE_URL: 'https://engage.dev.xref.com/',
  ENGAGE_ADMIN_URL: 'https://engage-admin.dev.xref.com/',
  ENGAGE_SURVEY_URL: 'https://survey.dev.xref.com/portal/logon',
  TRUST_MARKETPLACE_URL: 'https://console.dev.trustmarketplace.com/',
  TRUST_MARKETPLACE_INFO_URL: 'https://www.trustmarketplace.com?src=xref-platform&ltyp=omni&cn=employer-app',
  XREF_ME_INFO_URL: 'https://www.xref.com/xref-me?src=xref-platform&ltyp=omni&cn=employer-app',
  XREF_CHAT_URL: {
    au: 'https://xrefy.dev.xref.com/',
  },
  use_global_id: true,
  STRIPE: {
    API_KEYS: {
      'xref-au':
        'pk_test_51QqpbQInxAZPhgalf8h5vNSd39IIipRzWYnyKdwfhwF9IdqxFtU9HqN5wQuxAgM0vnM4ptU9Wnexh6ORRhzwAqRh00ZU9dLYqg',
      'xref-usa':
        'pk_test_51QqqIRLWT3NvXghxQTpTRSllbjOYo2IxdT8LTzGIg0o6l4fPx8NueE5cFFChlD3Xzxi4queBgU6rzmOWwr8PDjIH00AWxpAYpT',
      'xref-nz':
        'pk_test_51R2NKYDntqOCVIPu17E78WdMzHmhsHFBSWyRwWDjv4GoaJBoj8D53iWSgtmUVvOrFfrVY43FRFeohvL5urV9RZo900JnqtQ2Px',
      'xref-uk':
        'pk_test_51R4EXvLiwuxwCPHXK2FrnY2NUNws5jHiv36yuTY0E29rIyAD2bNQSX7ibz1PqgICutEWz12k5VRaB4v8jLD9VAz300L0gWuNQY',
      'xref-can':
        'pk_test_51R2O3uLZOjpvlczqjccpMZU6sFopud0E20iel40ziUo5ksD02LsEcSvaWzv6RkLh1i2Uv8TVCbs8LBa3zlShn9zK00epiBwTrF',
    },
    DEFAULT_REGION: 'xref-au',
  },
  G2_FORMS_BASE_URL: 'https://www.g2.com/partnerships/Xref/users/login.embed',
  APPSYNC: {
    au: {
      ENDPOINT: 'https://svw2ski265fhvn5bxopp6z3lie.appsync-api.ap-southeast-2.amazonaws.com/event',
      REGION: 'ap-southeast-2',
    },
  },
};
